import { StreamMetadata } from "./streamMetadata";
import { decodeVarintInt32 } from "../../decoding/integerDecodingUtils";
export class RleEncodedStreamMetadata extends StreamMetadata {
    _runs;
    _numRleValues;
    /**
     * @param numValues After LogicalLevelTechnique was applied -> numRuns + numValues
     * @param _runs Length of the runs array
     * @param _numRleValues Used for pre-allocating the arrays on the client for faster decoding
     */
    constructor(physicalStreamType, logicalStreamType, logicalLevelTechnique1, logicalLevelTechnique2, physicalLevelTechnique, numValues, byteLength, _runs, _numRleValues) {
        super(physicalStreamType, logicalStreamType, logicalLevelTechnique1, logicalLevelTechnique2, physicalLevelTechnique, numValues, byteLength);
        this._runs = _runs;
        this._numRleValues = _numRleValues;
    }
    static decode(tile, offset) {
        const streamMetadata = StreamMetadata.decode(tile, offset);
        const rleInfo = decodeVarintInt32(tile, offset, 2);
        return new RleEncodedStreamMetadata(streamMetadata.physicalStreamType, streamMetadata.logicalStreamType, streamMetadata.logicalLevelTechnique1, streamMetadata.logicalLevelTechnique2, streamMetadata.physicalLevelTechnique, streamMetadata.numValues, streamMetadata.byteLength, rleInfo[0], rleInfo[1]);
    }
    static decodePartial(streamMetadata, tile, offset) {
        const rleInfo = decodeVarintInt32(tile, offset, 2);
        return new RleEncodedStreamMetadata(streamMetadata.physicalStreamType, streamMetadata.logicalStreamType, streamMetadata.logicalLevelTechnique1, streamMetadata.logicalLevelTechnique2, streamMetadata.physicalLevelTechnique, streamMetadata.numValues, streamMetadata.byteLength, rleInfo[0], rleInfo[1]);
    }
    get runs() {
        return this._runs;
    }
    get numRleValues() {
        return this._numRleValues;
    }
    /**
     * Override to return the decompressed count for RLE streams.
     */
    getDecompressedCount() {
        return this._numRleValues;
    }
}
//# sourceMappingURL=rleEncodedStreamMetadata.js.map